import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useLocation } from 'react-router-dom';
import { Modal } from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux';
import { setSingpassError } from 'redux/reducers/auth'; // You'll need to create this action

import { ROUTES } from 'config/constants';
import { checkoutRules, getUserCart } from 'api/cart';

import FullscreenLoader from '../../components/FullscreenLoader/FullscreenLoader';
import Button from 'containers/App/components/Button/Button';
import { notifType, notify } from 'utils/notifSender';

import { storeUserEvent } from 'api/user';

import dangerSign from '../../assets/images/danger-sign.png';
import close from '../../assets/images/general/close.svg';
import { logout } from 'api/auth';
import { deleteAuthToken } from 'utils/helpers';

import './SingpassResult.scss';
import { trackKlaviyoEvent } from 'api/tracking';

const SingpassResultContainer = ({ profile }) => {
    const location = useLocation();
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(true);
    const [open] = useState(false);
    const [openForDuplicateNRIC, setOpenForDuplicateNRIC] = useState(false);
    const products = localStorage.getItem('products') ? JSON.parse(localStorage.getItem('products')) : [];
    const { segment } = useSelector(state => ({ segment: state.common.segment }));
    const segmentQuery = segment ? `?segment=${segment}` : '';
    const dispatch = useDispatch();

    useEffect(() => {
        window.document.title = 'Singpass Result';
    }, []);

    const checkSingpassStatus = status => {
        if (status === 'success') {
            trackKlaviyoEvent('singpass_successful', { email: profile?.email, user_id: profile?.id });
            triggerUserEvent('singpass_success');
            checkUserCart();
        } else if (status === 'duplicate_nric_fin') {
            setIsLoading(false);
            dispatch(setSingpassError('duplicate'));
            triggerUserEvent('singpass_duplicate_nric_fin');
            history.push(ROUTES.CART);
        } else {
            setIsLoading(false);
            dispatch(setSingpassError('error'));
            triggerUserEvent('singpass_error');
            history.push(ROUTES.CART);
        }
    };

    const triggerUserEvent = async (event) => {
        const payload = {
            event: event
        };

        await storeUserEvent(payload);
    };

    const checkUserCart = async () => {
        const resp = await getUserCart();

        if (resp?.data?.products?.length > 0) {
            validateCheckout();
        } else {
            setIsLoading(false);

            if (products?.length > 0) {
                // if (profile?.is_student || profile?.pass_proof_of_expiry_required) {
                //     history.push(ROUTES.DOCUMENTSPROOF);
                // } else {
                //     history.push(ROUTES.ORDER_SUMMARY);
                // }
                // history.push(ROUTES.ORDER_SUMMARY);
                // TODO: Refactor needed
                window.location.href = ROUTES.ORDER_SUMMARY;
            } else {
                history.push(ROUTES.CART);
            }
        }
    };

    const validateCheckout = async () => {
        const resp = await checkoutRules();

        setIsLoading(false);

        if (resp?.status === 204) {
            // if (profile?.is_student || profile?.pass_proof_of_expiry_required) {
            //     if (profile?.pass_proof_of_expiry_required) {
            //         history.push(ROUTES.DOCUMENTSPROOF);
            //     } else {
            //         history.push(ROUTES.ORDER_SUMMARY);
            //     }
            // } else {
            //     history.push(ROUTES.ORDER_SUMMARY);
            // }
            window.location.href = ROUTES.ORDER_SUMMARY;
        } else {
            notify(resp?.data?.message?.message, notifType.DANGER, 5000);
            history.push(ROUTES.CART);
        }
    };

    useEffect(() => {
        if (!location.search) {
            history.push(ROUTES.HOME + segmentQuery);

            return;
        }

        checkSingpassStatus(location.search.split('?status=')[1]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleClose = () => {
        setOpenForDuplicateNRIC(false);
    };

    const handleSignIn = async () => {
        try {
            setIsLoading(true);
            await logout();
            await deleteAuthToken();
            window.location.replace(ROUTES.SIGN_IN);
        } catch (error) {
            console.error('Error logging out:', error);
        }
    };

    return (
        <div style={{ height: '60vh' }}>
            {isLoading && <FullscreenLoader />}
            <Modal
                isOpen={open}
                centered={true}
                className='modalError'>
                <div className='errorModal'>
                    <div className='errorModal__logo'><img src={dangerSign} alt='Danger Sign' /></div>
                    <div className='errorModal__text'>We are not able to retrieve your information from Singpass.</div>
                    <div>
                        <Button
                            className='submit'
                            onClick={() => window.location.replace(ROUTES.CART)}
                            title='Proceed with your application' />
                    </div>
                </div>
            </Modal>
            <Modal
                centered={true}
                className='modalErrorDuplicate'
                isOpen={openForDuplicateNRIC}>
                <div className='errorModal'>
                    <button className='errorModal__close' onClick={handleClose}>
                        <img src={close} alt='Close' />
                    </button>
                    <div className='errorModal__logo'><img src={dangerSign} alt='Danger Sign' /></div>
                    <div className='errorModal__text'>Singpass Already Connected</div>
                    <div className='errorModal__instructions'>
                        <p><span className='errorModal__instructions__bold'>Oops!</span> It seems your Singpass is already linked to a different email.</p>
                        <ul>
                            <li>Please use the original email you have registered with Singpass.</li>
                            <li>We have sent an email to that account so you can easily find it in case you have forgotten.</li>
                            <li>If you no longer have access to that email or believe this is an error, please contact our <span className='errorModal__instructions__bold'>customer support</span> team for assistance.</li>
                        </ul>
                    </div>
                </div>
                <div className='errorModal__buttons'>
                    <div className='errorModal__buttons__container'>
                        <Button
                            className='contactUs'
                            onClick={() => history.push(ROUTES.CONTACT_US)}
                            title='Contact Us' />
                        <Button
                            className='signIn'
                            onClick={handleSignIn}
                            title='Sign In' />
                    </div>
                </div>
            </Modal>
        </div>
    );
};

SingpassResultContainer.propTypes = {
    profile: PropTypes.object
};

export default SingpassResultContainer;
